import React from 'react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Trash2 } from 'lucide-react';
import { CLASSES, inr } from './api';

export function VendorInvoiceLines({ lines, setLines, poLines, poId, ro }) {
  const options = poId ? poLines.filter(p => p.po_id === poId) : poLines;
  const byId = Object.fromEntries(poLines.map(p => [p.id, p]));
  const upd = (i, k, v) => setLines(lines.map((l, j) => (j === i ? { ...l, [k]: v, ...(k === 'po_line_id' ? { match_score: null } : {}) } : l)));
  const num = (i, k) => ({ type: 'number', disabled: ro, value: lines[i][k] ?? '', onChange: e => upd(i, k, e.target.value), className: 'h-8 text-right' });

  if (!lines.length) return <div className="text-xs text-muted-foreground border rounded p-3" data-testid="vi-lines-empty">No lines — load them from the PO or add them manually.</div>;
  return (
    <div className="border rounded overflow-x-auto">
      <table className="w-full text-xs">
        <thead className="bg-muted/50 text-left"><tr><th className="p-1.5 w-[24%]">Billed item</th><th className="w-16">Billed qty</th><th className="w-16">Received</th><th className="w-24">Actual rate</th><th className="w-20">GST %</th><th className="w-[28%]">Matched PO line</th><th className="text-right w-24">Amount</th><th /></tr></thead>
        <tbody>
          {lines.map((l, i) => {
            const pl = byId[l.po_line_id];
            const short = (+l.quantity || 0) - (l.received_qty === '' || l.received_qty == null ? +l.quantity || 0 : +l.received_qty);
            return (
              <tr key={l.id || i} className="border-t align-top" data-testid={`vi-line-${i}`}>
                <td className="p-1"><Input disabled={ro} className="h-8" value={l.description} onChange={e => upd(i, 'description', e.target.value)} data-testid={`vi-line-desc-${i}`} /></td>
                <td className="p-1"><Input {...num(i, 'quantity')} data-testid={`vi-line-qty-${i}`} /></td>
                <td className="p-1"><Input {...num(i, 'received_qty')} placeholder={String(l.quantity ?? '')} data-testid={`vi-line-recv-${i}`} />{short > 0 && <div className="text-[10px] text-red-600 mt-0.5">short {short}</div>}</td>
                <td className="p-1"><Input {...num(i, 'rate')} data-testid={`vi-line-rate-${i}`} />{pl && +l.rate !== +pl.rate && <div className="text-[10px] text-amber-700 mt-0.5">PO {inr(pl.rate)}</div>}</td>
                <td className="p-1"><Input {...num(i, 'gst_percent')} data-testid={`vi-line-gst-${i}`} /></td>
                <td className="p-1 space-y-1">
                  <Select disabled={ro} value={l.po_line_id || 'none'} onValueChange={v => upd(i, 'po_line_id', v === 'none' ? null : v)}>
                    <SelectTrigger className="h-8" data-testid={`vi-line-match-${i}`}><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="none">Not on a PO</SelectItem>
                      {options.map(p => <SelectItem key={p.id} value={p.id}>{p.po_number} · {p.description} (left {p.remaining_qty})</SelectItem>)}
                    </SelectContent>
                  </Select>
                  {l.match_score != null && <div className="text-[10px] text-green-700">auto-matched {Math.round(l.match_score * 100)}%</div>}
                  {!l.po_line_id && (
                    <Select disabled={ro} value={l.classification || ''} onValueChange={v => upd(i, 'classification', v)}>
                      <SelectTrigger className="h-8" data-testid={`vi-line-class-${i}`}><SelectValue placeholder="Goes to… (required)" /></SelectTrigger>
                      <SelectContent>{CLASSES.map(c => <SelectItem key={c} value={c}>{c.charAt(0) + c.slice(1).toLowerCase()}</SelectItem>)}</SelectContent>
                    </Select>
                  )}
                </td>
                <td className="p-1 text-right pt-2.5">{inr((+l.quantity || 0) * (+l.rate || 0) * (1 + (+l.gst_percent || 0) / 100))}</td>
                <td className="p-1">{!ro && <Button variant="ghost" size="sm" onClick={() => setLines(lines.filter((_, j) => j !== i))} data-testid={`vi-line-remove-${i}`}><Trash2 className="w-3 h-3" /></Button>}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
